// src/components/TimeSeriesChart.js
import React from "react";
import InterviewChartRecent from "./InterviewChartRecent";

const RECENT_GROUP_OPTIONS = ["歩行機能", "上肢機能", "疲労", "高次脳機能"];

export default function TimeSeriesChart({ data }) {
  return (
    <div>
      <section style={{ flex: 1, minWidth: "300px" }}>
        <InterviewChartRecent
          apiData={data}  // ← 新しいpropを渡す
          selectedGroups={RECENT_GROUP_OPTIONS}
          showChart={true}
          showTable={false}
          showRangeSwitcher={false}
          fixedMonths={36}
        />
      </section>
    </div>
  );
}